import React, { useState } from "react";
import { Form, Button, Modal, Checkbox, Message, Icon, Loader } from "semantic-ui-react";
import { determineFuelsUnits } from "../../../../utils/dataAndFormulas/fuelsForms";
import { useLanguage } from "../../../../contexts";
import "./UpdateUnitsModal.scss";

export function UpdateUnitsModal(props) {
  const { show, onClose, onApply, currentUnits, registeredFields, isLoading } = props;
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  // Estado para campos seleccionados y sus unidades
  const [selectedFields, setSelectedFields] = useState({});
  const [fieldUnits, setFieldUnits] = useState({});

  // Lista de todos los campos de combustibles
  const allFuelsFields = [
    { key: "natural_gas", label: t("natural_gas") },
    { key: "natural_gas_cost", label: t("natural_gas_cost") },
    { key: "glp", label: t("glp") },
    { key: "glp_cost", label: t("glp_cost") },
    { key: "diesel", label: t("diesel") },
    { key: "diesel_cost", label: t("diesel_cost") },
    { key: "biodiesel", label: t("biodiesel") },
    { key: "cost_biodiesel", label: t("cost_biodiesel") },
    { key: "gasoline", label: t("gasoline") },
    { key: "gasoline_cost", label: t("gasoline_cost") },
    { key: "ethanol", label: t("ethanol") },
    { key: "ethanol_cost", label: t("ethanol_cost") },
    { key: "electricity_vehicles", label: t("electricity_vehicles") },
    { key: "cost_electricity_vehicles", label: t("cost_electricity_vehicles") },
    { key: "natural_gas_vehicles", label: t("natural_gas_vehicles") },
    { key: "glp_vehicles", label: t("glp_vehicles") },
    { key: "diesel_vehicles", label: t("diesel_vehicles") },
    { key: "biodiesel_vehicles", label: t("biodiesel_vehicles") },
    { key: "gasoline_vehicles", label: t("gasoline_vehicles") },
    { key: "ethanol_vehicles", label: t("ethanol_vehicles") },
    { key: "electric_vehicles", label: t("electric_vehicles") },
  ];

  // Filtrar campos según registeredFields si existen
  const fuelsFields =
    registeredFields && registeredFields.length > 0
      ? registeredFields
          .filter((field) => field.active !== false)
          .map((field) => ({
            key: field.name,
            label: t(field.name),
            code: field.code,
          }))
      : allFuelsFields;

  const handleFieldToggle = (fieldKey, checked) => {
    setSelectedFields(prev => ({
      ...prev,
      [fieldKey]: checked
    }));

    // Si se selecciona, inicializar con la unidad actual
    if (checked && !fieldUnits[fieldKey]) {
      setFieldUnits(prev => ({
        ...prev,
        [fieldKey]: currentUnits?.[fieldKey] || ""
      }));
    }
  };

  const handleUnitChange = (fieldKey, unit) => {
    setFieldUnits(prev => ({
      ...prev,
      [fieldKey]: unit
    }));
  };

  const handleSelectAll = () => {
    const allSelected = {};
    const allUnits = {};
    fuelsFields.forEach(field => {
      allSelected[field.key] = true;
      allUnits[field.key] = currentUnits?.[field.key] || "";
    });
    setSelectedFields(allSelected);
    setFieldUnits(allUnits);
  };

  const handleDeselectAll = () => {
    setSelectedFields({});
  };

  const handleApply = () => {
    // Filtrar solo los campos seleccionados con sus unidades
    const unitsToApply = {};
    Object.keys(selectedFields).forEach(key => {
      if (selectedFields[key] && fieldUnits[key]) {
        unitsToApply[key] = fieldUnits[key];
      }
    });

    if (Object.keys(unitsToApply).length === 0) {
      return;
    }

    onApply(unitsToApply);
  };

  const selectedCount = Object.values(selectedFields).filter(Boolean).length;

  return (
    <Modal open={show} onClose={onClose} size="large" className="update-units-modal">
      {/* <Modal.Header>
        <Icon name="edit" />
        {t("update_units_in_forms") || "Modificar unidades en formularios existentes"}
      </Modal.Header> */}
      <Modal.Content>
        <div className="update-units-modal__title">{t("update_units_in_forms") || "Modificar unidades"}</div>
        {/* <Message info>
          <Message.Header>{t("select_fields_to_update") || "Selecciona los campos a modificar"}</Message.Header>
          <p>
            {t("update_units_description") ||
              "Selecciona los campos y las unidades que deseas aplicar a todos los formularios existentes del año."}
          </p>
        </Message> */}

        <div style={{ marginBottom: "15px" }}>
          <Button size="small" className="btn-select-all" onClick={handleSelectAll}>
            <Icon name="check square" /> {t("select_all") || "Seleccionar todos"}
          </Button>
          <Button size="small" className="btn-deselect-all" onClick={handleDeselectAll}>
            <Icon name="square outline" /> {t("deselect_all") || "Deseleccionar todos"}
          </Button>
          <span style={{ marginLeft: "15px", color: "#666" }}>
            {selectedCount} {t("fields_selected") || "campos seleccionados"}
          </span>
        </div>

        <Form>
          <div className="update-units-grid">
            {fuelsFields.map((field) => (
              <div key={field.key} className="update-unit-row">
                <Checkbox
                  checked={selectedFields[field.key] || false}
                  onChange={(_, data) => handleFieldToggle(field.key, data.checked)}
                  label={field.label}
                  className="field-checkbox"
                />
                {selectedFields[field.key] && (
                  <Form.Dropdown
                    placeholder={t("select_unit")}
                    options={determineFuelsUnits(field.key).map((unit) => ({
                      key: unit.key,
                      text: t(unit.name),
                      value: unit.value,
                    }))}
                    selection
                    search
                    compact
                    value={fieldUnits[field.key] || ""}
                    onChange={(_, data) => handleUnitChange(field.key, data.value)}
                    className="unit-dropdown"
                  />
                )}
              </div>
            ))}
          </div>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          onClick={handleApply}
          disabled={selectedCount === 0 || isLoading}
          loading={isLoading}
        >
          <Icon name="save" />
          {t("apply_to_forms") || `Aplicar a formularios (${selectedCount})`}
        </Button>
        <Button secondary onClick={onClose} disabled={isLoading}>
          {t("cancel")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
